import URL from '@/util/url';

const isWXApplet = URL.isWXApplet;
export const channel = isWXApplet ? 5 : 3;
export const source = isWXApplet ? 'wxApplet' : 'kdbApp';

export const SlotCode = {
  HOME_BANNER: 1101,
  HOME_MODAL: 1102,
  BILL_BANNER: 1201,
};

export const cdbVersion = '0.0.1';

export const ReportType = {
  REQUEST: 1,
  MV: 2,
  MC: 3,
};
